import styled from 'styled-components';
import { ThemeColours } from '../../../../styles/ThemeColours';
import { PRESSABLE } from '../../../../styles/constants';
import { Button as BaseButton } from '../../../Button/Button';
import { LoginButton } from '../../../CorporateGroupIdentity/LoginButton/LoginButton';

export const IdentityProviderModalButton = styled(BaseButton)`
  font-size: 16px;
  height: 44px;
  margin: 0 0 0 12px;
  text-align: center;
  width: auto;
`;

export const IdentityProviderContinueButton = styled(LoginButton)`
  ${PRESSABLE}
  border: 2px solid ${ThemeColours.mono200};
  color: ${ThemeColours.black};
  font-size: 16px;
  margin: 16px 0;
  padding: 0px 24px;
  width: 300px;

  &:hover {
    background: ${ThemeColours.mono100};
  }
`;

export const IdentityProviderLoginButton = styled(IdentityProviderContinueButton)`
  background-color: ${ThemeColours.white};
`;

export const Container = styled.div`
  align-items: center;
  display: flex;
  flex-flow: column nowrap;
  min-height: 0;
  overflow: hidden;
`;
